import * as React from "react";
import Button from "@material-ui/core/Button";
import { CircularProgress, createStyles, makeStyles, Theme } from "@material-ui/core";
import { ReactNode } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    disabledButton: {
      opacity: 0.7,
    },
  })
);

export const SubmitButton: React.FC<{
  isSubmitting: boolean;
  isValid: boolean;
  handleSubmit?: any;
  label?: ReactNode;
  type?: "submit" | "button" | "reset" | undefined;
}> = ({ isSubmitting, isValid, handleSubmit, label = "Submit", type = "submit", ...props }) => {
  const classes = useStyles();
  return (
    <Button
      size={"large"}
      type={type}
      variant={"contained"}
      color={"primary"}
      disabled={isSubmitting || !isValid}
      fullWidth={true}
      onClick={handleSubmit}
      classes={{ disabled: classes.disabledButton }}
      {...props}
    >
      {isSubmitting ? <CircularProgress size={24} /> : label}
    </Button>
  );
};
